<template>
	<div>
		<DropdownComp class="" triggerClass="rounded-md h-10" label="" insideLabel="Hub" :options="hubs"
			v-model="hubSelected" />
	</div>
</template>

<script>
import DropdownComp from './DropdownComp.vue'

export default {
	name: 'ChangeHub',

	components: {
		DropdownComp
	},

	data() {
		return {
			hubs: [
				{ label: 'Jakarta', value: 'jakarta', disabled: false },
				{ label: 'Singapore', value: 'singapore', disabled: true },
				{ label: 'Hong Kong', value: 'hongKong', disabled: true },
				{ label: 'Dubai', value: 'dubai', disabled: true },
				{ label: 'Sidney', value: 'sidney', disabled: true },
				{ label: 'London', value: 'london', disabled: true },
				{ label: 'New York', value: 'newYork', disabled: true },
				{ label: 'Zurich', value: 'zurich', disabled: true },
			],

			hubSelected: 'jakarta'
		}
	},

	watch: {
		hubSelected(newValue) {
			// this.changeHub(newValue)
		}
	},

	methods: {
		changeHub(newHub) {
			this.$store.dispatch('changeHub', newHub)
		}
	}
}
</script>

<style scoped>

</style>